import React from "react";
import "../styles/StripesHelppanel.css";

interface HelppanelProps {
  isOpenPanel: boolean;
  setisOpenPanel: (value: boolean) => void;
}

const Helppanel: React.FC<HelppanelProps> = ({ isOpenPanel, setisOpenPanel }) => {
  const handleclick = () => {
    setisOpenPanel(false);
  };

  return (
    <div className="s-helpPanel" id="s-helpPanel" hidden={!isOpenPanel}>
      <img
        src="/img/close.svg"
        id="s-closeButton"
        className="s-closeButton"
        alt="Close panel"
        onClick={handleclick}
      />
      <div className="s-helpPivots">
        <div id="s-pivotModes" className="activePivot">
          Правила игры
        </div>
      </div>
      <div id="s-modesCards">
        <div className="s-helpCard">
          <div>
            Чтобы начать игру, нажми кнопку "Начать игру" — появится таймер и
            разрезанная картинка. Перетягивай полоски в пустые ячейки справа:
            если полоска встала правильно, она подсветится зелёным. Если ошибся
            — просто кликни по неправильной полоске, и она вернётся обратно.
            Собери всю картинку быстрее всех, удачи!
          </div>
        </div>
      </div>
    </div>
  );
};

export default Helppanel;
